import { render, staticRenderFns } from "./SearchNavItemCompany.vue?vue&type=template&id=fd9cd066&scoped=true"
import script from "./SearchNavItemCompany.vue?vue&type=script&lang=js"
export * from "./SearchNavItemCompany.vue?vue&type=script&lang=js"
import style0 from "./SearchNavItemCompany.vue?vue&type=style&index=0&id=fd9cd066&prod&scoped=true&lang=css"
import style1 from "./SearchNavItemCompany.vue?vue&type=style&index=1&id=fd9cd066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9cd066",
  null
  
)

export default component.exports